export const getHomeRouteForRole = (role) => {
  if (role === "SuperAdmin") return "/admin";
  if (role === "Villager") return "/villager";
  return "/dashboard";
};
